import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  ViewChild,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterTab } from '../../../models';

@Component({
  selector: 'app-filter-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './filter-tabs.component.html',
  styleUrl: './filter-tabs.component.scss',
})
export class FilterTabsComponent implements OnInit, OnDestroy {
  @Input() tabs: FilterTab[] = [];
  @Input() activeTab: string = '';
  @Output() tabChange = new EventEmitter<string>();

  @ViewChild('dropdown', { static: false }) dropdownRef?: ElementRef;

  isMobile = false;
  showDropdown = false;

  ngOnInit() {
    this.checkScreen();
  }

  ngOnDestroy() {
    // Clean up any event listeners if needed
  }

  @HostListener('window:resize')
  checkScreen() {
    this.isMobile = window.innerWidth < 768; // breakpoint for mobile
    // Close dropdown on screen size change
    if (!this.isMobile) {
      this.showDropdown = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Close dropdown if clicking outside
    if (
      this.showDropdown &&
      this.dropdownRef &&
      !this.dropdownRef.nativeElement.contains(event.target)
    ) {
      this.showDropdown = false;
    }
  }

  onTabClick(tabId: string) {
    this.tabChange.emit(tabId);
    // Close dropdown after selection on mobile
    if (this.isMobile) {
      this.showDropdown = false;
    }
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  trackByFn(index: number, item: FilterTab) {
    return item.id;
  }

  getActiveTabLabel(): string {
    const activeTab = this.tabs.find((tab) => tab.id === this.activeTab);
    return activeTab ? activeTab.label : 'Filter';
  }
}
